import { gql } from "@apollo/client";

const GET_DATA_FRESHNESS_TIMESTAMPS = gql`
  query getDataFreshnessTimestamps {
    dataFreshnessTimestamps {
      profileToProfileAffinities
      githubComments
      engineeringPerformanceWeeklyScores
      scoringUnifiedWeeklyScores
      atsReportsWeekly
      engineeringPerformanceWeeklyScoresFormulaComponents
      teamAssignmentPeriodDimensions
      profileVideoInterviewTranscripts
      clientFeedback
      missionRoleRateRecommendations
      githubUsers
      signalInsights
      atsReportsAllTime
      teamDynamicsWeeklyScores
      githubDailyUserCommits
      pulseWeeklyScores
      missionRoles
      missionRoleProfileRecommendations
      monthlyTeamSurveyAnswers
      timeCardReportAllTime
      githubActivities
      githubPullRequests
      githubWeeklyAggregations
      currencyConversionRates
      missionRoleApplicants
      githubUserDailyReports
      githubCommits
      clientSatisfactionWeeklyScores
      omnisearch
      profiles
      missionRoleTimelines
      missionRoleProfileScores
      chartDataPlatformTimeSlips
      profileTimelines
    }
  }
`;

export { GET_DATA_FRESHNESS_TIMESTAMPS };
